module.exports = __webpack_public_path__ + "img/kommune-522.54c7a67b.svg";